import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../services/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [senha, setSenha] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (senha.length < 8) { setErr("Senha mínima: 8 caracteres."); return; }
    try {
      await api.post("/confirm_password_reset.php", { token, new_password: senha });
      setMsg("Senha redefinida. Você já pode entrar.");
    } catch {
      setErr("Token inválido ou expirado.");
    }
  }

  return (
    <div className="min-h-screen bg-[#0b0f19] flex items-center justify-center">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-[#1f2937] bg-[#121826] p-6">
        <h1 className="text-xl font-semibold text-slate-100">Nova senha</h1>
        {msg && <p className="mt-4 text-sm text-green-400">{msg}</p>}
        {err && <p className="mt-4 text-sm text-red-400">{err}</p>}
        <input
          type="password" required placeholder="Nova senha"
          value={senha} onChange={e=>setSenha(e.target.value)}
          className="mt-6 w-full rounded-xl border border-[#1f2937] bg-[#0b0f19] px-4 py-3 text-slate-100"
        />
        <button className="mt-6 w-full rounded-xl bg-blue-600 py-3 text-sm font-semibold hover:bg-blue-500">
          Salvar senha
        </button>
      </form>
    </div>
  );
}
